skrilla.directive('refundWithdrawalDetails', function () {
    return {
        templateUrl: 'directives/withdrawalDetails/refundWithdrawalDetails.html',
        scope: {
            withdrawal: "="
        },
        controller: function ($scope, searchService, modalService, currencyService, envService, validationService, withdrawalService) {
            $scope.bounce = withdrawalService.bounceWithdrawal;
        }
    };
});
